import {
  GET_CHECKLIST,
  GET_CHECKLIST_SUCCESS,
  GET_CHECKLIST_FAIL,
  ADD_CHECKLIST,
  ADD_CHECKLIST_SUCCESS,
  ADD_CHECKLIST_FAIL,
  UPDATE_CHECKLIST,
  UPDATE_CHECKLIST_SUCCESS,
  UPDATE_CHECKLIST_FAIL,
  DELETE_CHECKLIST,
  DELETE_CHECKLIST_SUCCESS,
  DELETE_CHECKLIST_FAIL,
  SET_CHECKLIST_FIELD_ERRORS,
} from './actionTypes'

// Get CheckList
export const getCheckList = (id) => ({
  type: GET_CHECKLIST,
  payload: id
})

export const getCheckListSuccess = (checklist) => ({
  type: GET_CHECKLIST_SUCCESS,
  payload: checklist,
})

export const getCheckListFail = (error) => ({
  type: GET_CHECKLIST_FAIL,
  payload: error,
})

// Add CheckList
export const addCheckList = (checklist) => ({
  type: ADD_CHECKLIST,
  payload: checklist,
})

export const addCheckListSuccess = (checklist) => ({
  type: ADD_CHECKLIST_SUCCESS,
  payload: checklist,
})

export const addCheckListFail = (error) => ({
  type: ADD_CHECKLIST_FAIL,
  payload: error,
})

// Update CheckList
export const updateCheckList = (checklist) => ({
  type: UPDATE_CHECKLIST,
  payload: checklist,
})

export const updateCheckListSuccess = (checklist) => ({
  type: UPDATE_CHECKLIST_SUCCESS,
  payload: checklist,
})

export const updateCheckListFail = (error) => ({
  type: UPDATE_CHECKLIST_FAIL,
  payload: error,
})

// Delete CheckList
export const deleteCheckList = (id, catalogueId) => ({
  type: DELETE_CHECKLIST,
  payload: { id, catalogueId },
})

export const deleteCheckListSuccess = (id) => ({
  type: DELETE_CHECKLIST_SUCCESS,
  payload: id,
})

export const deleteCheckListFail = (error) => ({
  type: DELETE_CHECKLIST_FAIL,
  payload: error,
})

// Set Field Errors
export const setCheckListFieldErrors = (errors) => ({
  type: SET_CHECKLIST_FIELD_ERRORS,
  payload: errors,
})
